export interface OutsideSchoolHoursReporting {
  includeActivity?: boolean;
  triggerRedFlags?: boolean;
}

export const equal = (a1?: OutsideSchoolHoursReporting, a2?: OutsideSchoolHoursReporting): boolean => {
  return !!a1?.includeActivity === !!a2?.includeActivity && !!a1?.triggerRedFlags === !!a2?.triggerRedFlags;
};
